import * as React from "react"

import { cn } from "@/lib/utils"
import { Search } from "lucide-react"

interface InputProps extends React.ComponentProps<"input"> {
  searchBar?: boolean;
  icon?: React.ReactNode;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, searchBar, icon, ...props }, ref) => {
    if (searchBar || icon) {
      return (
        <div className="relative w-full">
          <span className="absolute top-1/2 left-3 -translate-y-1/2">
            {icon || (searchBar && <Search className="h-4 w-4 text-muted-foreground" />)}
          </span>
          <input
            type={type}
            data-slot="input"
            className={cn(
              "flex h-10 w-full rounded-lg border border-input bg-background px-3 py-2 text-base file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-input-color focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
              "focus-visible:border-ring",
              "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
              (searchBar || icon) && "pl-10",
              className
            )}
            ref={ref}
            {...props}
          />
        </div>
      );
    }
    return (
      <input
        type={type}
        data-slot="input"
        className={cn(
          "flex h-10 w-full rounded-lg border border-input bg-background px-3 py-2 text-base file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-input-color focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          "focus-visible:border-ring",
          "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
)
Input.displayName = "Input"

export { Input }
export type { InputProps }
